import NewApplicationWorkflow from './newapplicationworkflow'
export const ExternalApplicationSidebar = {
    'MPSCONNECTIONS': {
        "type": "applicationdrawer",
        "order": 2,
        "key": "drawer",
        "options": {
            "icon": "alarm",
            "open": true,
            "iconsonly": true,
            anchor: 'right',
            orientation: 'vertical',
            "items": [
                {
                    "type": "menu",
                    "title": "Contacts",
                    "icon": "fa fa-user-circle-o",
                    "materialicon": "contacts",
                    "style": {
                        'color': '#64b5f6'
                    },
                    "link": [
                        {
                            "routes": [
                                {
                                    "route": "/Records",
                                    "routeParams": "key",
                                },
                                {
                                    "route": "",
                                    "routeParams": "routeid"
                                },
                                {
                                    "route": "",
                                    "routeParams": "routeid1"
                                },
                                {
                                    "route": "/contacts",
                                },
                            ],
                        }
                    ],
                    key: 'contacts'
                },
                {
                    "type": "menu",
                    "title": "Taxlots",
                    "icon": "fa fa-sticky-note-o",
                    "materialicon": "beenhereoutlined",
                    "style": {
                        'color': '#607d8b'
                    },
                    "link": [
                        {
                            "routes": [
                                {
                                    "route": "/Records",
                                    "routeParams": "key",
                                },
                                {
                                    "route": "",
                                    "routeParams": "routeid"
                                },
                                {
                                    "route": "",
                                    "routeParams": "routeid1"
                                },
                                {
                                    "route": "/taxlots",
                                },
                            ]
                        }
                    ],
                    "key": "taxlots"
                },
                {
                    "type": "menu",
                    "title": "Multiple Locations",
                    "icon": "fa fa-sticky-note-o",
                    "materialicon": "edit_location",
                    "style": {
                        'color': '#820404'
                    },
                    "link": [
                        {
                            "routes": [
                                {
                                    "route": "/Records",
                                    "routeParams": "key",
                                },
                                {
                                    "route": "",
                                    "routeParams": "routeid"
                                },
                                {
                                    "route": "",
                                    "routeParams": "routeid1"
                                },
                                {
                                    "route": "/multiplelocations",
                                },
                            ]
                        }
                    ],
                    "key": "multiplelocations"
                },
                {
                    "type": "menu",
                    "title": "Comments",
                    "icon": "fa fa-sticky-note-o",
                    "materialicon": "note",
                    "style": {
                        'color': '#b26a00'
                    },
                    "link": [
                        {
                            "routes": [
                                {
                                    "route": "/Records",
                                    "routeParams": "key",
                                },
                                {
                                    "route": "",
                                    "routeParams": "routeid"
                                },
                                {
                                    "route": "",
                                    "routeParams": "routeid1"
                                },
                                {
                                    "route": "/notes",
                                },
                            ],
                        }
                    ],
                    "key": "notes"
                },
                {
                    "type": "menu",
                    "title": "Attachments",
                    "icon": "fa fa-paperclip",
                    "materialicon": "attach_file",
                    "style": {
                        'color': '#f48fb1'
                    },
                    "link": [
                        {
                            "routes": [
                                {
                                    "route": "/Records",
                                    "routeParams": "key",
                                },
                                {
                                    "route": "",
                                    "routeParams": "routeid"
                                },
                                {
                                    "route": "",
                                    "routeParams": "routeid1"
                                },
                                {
                                    "route": "/attachments",
                                },
                            ],
                        }
                    ],
                    "key": "attachments"
                },
                {
                    "type": "menu",
                    "title": "Notices",
                    "icon": "fa fa-files-o",
                    "materialicon": "tab",
                    "style": {
                        'color': '#8bc34a'
                    },
                    "link": [
                        {
                            "routes": [
                                {
                                    "route": "/Records",
                                    "routeParams": "key",
                                },
                                {
                                    "route": "",
                                    "routeParams": "routeid"
                                },
                                {
                                    "route": "",
                                    "routeParams": "routeid1"
                                },
                                {
                                    "route": "/notices",
                                },
                            ],
                        }
                    ],
                    key: 'notices'
                },
                {
                    "type": "menu",
                    "title": "Images",
                    "icon": "fa fa-files-o",
                    "materialicon": "wallpaper",
                    "style": {
                        'color': '#ffb300'
                    },
                    "link": [
                        {
                            "routes": [
                                {
                                    "route": "/Records",
                                    "routeParams": "key",
                                },
                                {
                                    "route": "",
                                    "routeParams": "routeid"
                                },
                                {
                                    "route": "",
                                    "routeParams": "routeid1"
                                },
                                {
                                    "route": "/images",
                                },
                            ],
                        }
                    ],
                    key: 'images'
                },

                {
                    "type": "menu",
                    "title": "Shared Discussions",
                    "icon": "fa fa-files-o",
                    "materialicon": "chat",
                    "style": {
                        'color': '#607d8b'
                    },
                    "link": [
                        {
                            "routes": [
                                {
                                    "route": "/Records",
                                    "routeParams": "key",
                                },
                                {
                                    "route": "",
                                    "routeParams": "routeid"
                                },
                                {
                                    "route": "",
                                    "routeParams": "routeid1"
                                },
                                {
                                    "route": "/discussions",
                                },
                            ],
                        }
                    ],
                    key: 'discussions'
                },
                {
                    "type": "menu",
                    "title": "Notification Log",
                    "icon": "fa fa-envelope-o",
                    "materialicon": "notifications_active",
                    "style": {
                        'color': '#40c4ff'
                    },
                    "link": [
                        {
                            "routes": [
                                {
                                    "route": "/Records",
                                    "routeParams": "key",
                                },
                                {
                                    "route": "",
                                    "routeParams": "routeid"
                                },
                                {
                                    "route": "",
                                    "routeParams": "routeid1"
                                },
                                {
                                    "route": "/notificationlog",
                                },
                            ],
                        }
                    ],
                    "key": "notificationlog"
                },
                {
                    "type": "menu",
                    "title": "Permit Amendments",
                    "icon": "fa fa-sticky-note-o",
                    "materialicon": "approval",
                    "style": {
                        'color': '#b26a00'
                    },
                    "link": [
                        {
                            "routes": [
                                {
                                    "route": "/Records",
                                    "routeParams": "key",
                                },
                                {
                                    "route": "",
                                    "routeParams": "routeid"
                                },
                                {
                                    "route": "",
                                    "routeParams": "routeid1"
                                },
                                {
                                    "route": "/permitamendments",
                                },
                            ],
                        }
                    ],
                    "key": "permitamendments"
                },
                {
                    "type": "menu",
                    "title": "History",
                    "icon": "fa fa-files-o",
                    "materialicon": "history",
                    "style": {
                        'color': '#f44336'
                    },
                    "link": [
                        {
                            "routes": [
                                {
                                    "route": "/Records",
                                    "routeParams": "key",
                                },
                                {
                                    "route": "",
                                    "routeParams": "routeid"
                                },
                                {
                                    "route": "",
                                    "routeParams": "routeid1"
                                },
                                {
                                    "route": "/history",
                                },
                            ],
                        }
                    ],
                    key: 'history'
                },
            ]
        }
    },
    'MPSCONNECTIONS': {
        "type": "applicationdrawer",
        "order": 2,
        "key": "drawer",
        "options": {
            "icon": "alarm",
            "open": true,
            "iconsonly": true,
            anchor: 'right',
            orientation: 'vertical',
            "items": [
                {
                    "type": "menu",
                    "title": "Site Reviews",
                    "icon": "fa fa-sticky-note-o",
                    "materialicon": "edit_road",
                    "style": {
                        'color': '#b26a00'
                    },
                    "link": [
                        {
                            "routes": [
                                {
                                    "route": "/Records",
                                    "routeParams": "key",
                                },
                                {
                                    "route": "",
                                    "routeParams": "routeid"
                                },
                                {
                                    "route": "",
                                    "routeParams": "routeid1"
                                },
                                {
                                    "route": "/sitereview",
                                },
                            ],
                        }
                    ],
                    "key": "sitereview"
                },
                {
                    "type": "menu",
                    "title": "Contacts",
                    "icon": "fa fa-user-circle-o",
                    "materialicon": "contacts",
                    "style": {
                        'color': '#64b5f6'
                    },
                    "link": [
                        {
                            "routes": [
                                {
                                    "route": "/Records",
                                    "routeParams": "key",
                                },
                                {
                                    "route": "",
                                    "routeParams": "routeid"
                                },
                                {
                                    "route": "",
                                    "routeParams": "routeid1"
                                },
                                {
                                    "route": "/contacts",
                                },
                            ],
                        }
                    ],
                    key: 'contacts'
                },
                // {
                //     "type": "menu",
                //     "title": "Multiple Locations",
                //     "icon": "fa fa-sticky-note-o",
                //     "materialicon": "edit_location",
                //     "style": {
                //         'color': '#820404'
                //     },
                //     "link": [
                //         {
                //             "routes": [
                //                 {
                //                     "route": "/Records",
                //                     "routeParams": "key",
                //                 },
                //                 {
                //                     "route": "",
                //                     "routeParams": "routeid"
                //                 },
                //                 {
                //                     "route": "",
                //                     "routeParams": "routeid1"
                //                 },
                //                 {
                //                     "route": "/multiplelocations",
                //                 },
                //             ]
                //         }
                //     ],
                //     "key": "multiplelocations"
                // },
                {
                    "type": "menu",
                    "title": "Comments",
                    "icon": "fa fa-sticky-note-o",
                    "materialicon": "note",
                    "style": {
                        'color': '#b26a00'
                    },
                    "link": [
                        {
                            "routes": [
                                {
                                    "route": "/Records",
                                    "routeParams": "key",
                                },
                                {
                                    "route": "",
                                    "routeParams": "routeid"
                                },
                                {
                                    "route": "",
                                    "routeParams": "routeid1"
                                },
                                {
                                    "route": "/notes",
                                },
                            ],
                        }
                    ],
                    "key": "notes"
                },

                {
                    "type": "menu",
                    "title": "Attachments",
                    "icon": "fa fa-paperclip",
                    "materialicon": "attach_file",
                    "style": {
                        'color': '#f48fb1'
                    },
                    "link": [
                        {
                            "routes": [
                                {
                                    "route": "/Records",
                                    "routeParams": "key",
                                },
                                {
                                    "route": "",
                                    "routeParams": "routeid"
                                },
                                {
                                    "route": "",
                                    "routeParams": "routeid1"
                                },
                                {
                                    "route": "/attachments",
                                },
                            ],
                        }
                    ],
                    "key": "attachments"
                },
                {
                    "type": "menu",
                    "title": "Images",
                    "icon": "fa fa-files-o",
                    "materialicon": "wallpaper",
                    "style": {
                        'color': '#ffb300'
                    },
                    "link": [
                        {
                            "routes": [
                                {
                                    "route": "/Records",
                                    "routeParams": "key",
                                },
                                {
                                    "route": "",
                                    "routeParams": "routeid"
                                },
                                {
                                    "route": "",
                                    "routeParams": "routeid1"
                                },
                                {
                                    "route": "/images",
                                },
                            ],
                        }
                    ],
                    key: 'images'
                },
                {
                    "type": "menu",
                    "title": "Notices",
                    "icon": "fa fa-files-o",
                    "materialicon": "tab",
                    "style": {
                        'color': '#8bc34a'
                    },
                    "link": [
                        {
                            "routes": [
                                {
                                    "route": "/Records",
                                    "routeParams": "key",
                                },
                                {
                                    "route": "",
                                    "routeParams": "routeid"
                                },
                                {
                                    "route": "",
                                    "routeParams": "routeid1"
                                },
                                {
                                    "route": "/notices",
                                },
                            ],
                        }
                    ],
                    key: 'notices'
                },

                {
                    "type": "menu",
                    "title": "Permit Amendments",
                    "icon": "fa fa-sticky-note-o",
                    "materialicon": "approval",
                    "style": {
                        'color': '#b26a00'
                    },
                    "link": [
                        {
                            "routes": [
                                {
                                    "route": "/Records",
                                    "routeParams": "key",
                                },
                                {
                                    "route": "",
                                    "routeParams": "routeid"
                                },
                                {
                                    "route": "",
                                    "routeParams": "routeid1"
                                },
                                {
                                    "route": "/permitamendments",
                                },
                            ],
                        }
                    ],
                    //hidecondition: [{ Name: "permitstage", Value: "WORK_PERMIT_APPROVED_EXTENDED_REACTIVATED" ,notEquals:true}],
                    "key": "permitamendments"
                },
                {
                    "type": "menu",
                    "title": "Shared Discussions",
                    "icon": "fa fa-files-o",
                    "materialicon": "chat",
                    "style": {
                        'color': '#607d8b'
                    },
                    "link": [
                        {
                            "routes": [
                                {
                                    "route": "/Records",
                                    "routeParams": "key",
                                },
                                {
                                    "route": "",
                                    "routeParams": "routeid"
                                },
                                {
                                    "route": "",
                                    "routeParams": "routeid1"
                                },
                                {
                                    "route": "/discussions",
                                },
                            ],
                        }
                    ],
                    key: 'discussions'
                },
                {
                    "type": "menu",
                    "title": "Notification Log",
                    "icon": "fa fa-envelope-o",
                    "materialicon": "notifications_active",
                    "style": {
                        'color': '#40c4ff'
                    },
                    "link": [
                        {
                            "routes": [
                                {
                                    "route": "/Records",
                                    "routeParams": "key",
                                },
                                {
                                    "route": "",
                                    "routeParams": "routeid"
                                },
                                {
                                    "route": "",
                                    "routeParams": "routeid1"
                                },
                                {
                                    "route": "/notificationlog",
                                },
                            ],
                        }
                    ],
                    "key": "notificationlog"
                },

                {
                    "type": "menu",
                    "title": "History",
                    "icon": "fa fa-files-o",
                    "materialicon": "history",
                    "style": {
                        'color': '#f44336'
                    },
                    "link": [
                        {
                            "routes": [
                                {
                                    "route": "/Records",
                                    "routeParams": "key",
                                },
                                {
                                    "route": "",
                                    "routeParams": "routeid"
                                },
                                {
                                    "route": "",
                                    "routeParams": "routeid1"
                                },
                                {
                                    "route": "/history",
                                },
                            ],
                        }
                    ],
                    key: 'history'
                },
            ]
        }
    },
    'MPSWHROW': {
        "type": "applicationdrawer",
        "order": 2,
        "key": "drawer",
        "options": {
            "icon": "alarm",
            "open": true,
            "iconsonly": true,
            anchor: 'right',
            orientation: 'vertical',
            "items": [
                {
                    "type": "menu",
                    "title": "Additional Contacts",
                    "icon": "fa fa-user-circle-o",
                    "materialicon": "contacts",
                    "style": {
                        'color': '#64b5f6'
                    },
                    "link": [
                        {
                            "routes": [
                                {
                                    "route": "/Records",
                                    "routeParams": "key",
                                },
                                {
                                    "route": "",
                                    "routeParams": "routeid"
                                },
                                {
                                    "route": "",
                                    "routeParams": "routeid1"
                                },
                                {
                                    "route": "/contacts",
                                },
                            ],
                        }
                    ],
                    key: 'contacts'
                },
                {
                    "type": "menu",
                    "title": "PLSS Locations",
                    "icon": "fa fa-sticky-note-o",
                    "materialicon": "edit_location",
                    "style": {
                        'color': '#2e8b57'
                    },
                    "link": [
                        {
                            "routes": [
                                {
                                    "route": "/Records",
                                    "routeParams": "key",
                                },
                                {
                                    "route": "",
                                    "routeParams": "routeid"
                                },
                                {
                                    "route": "",
                                    "routeParams": "routeid1"
                                },
                                {
                                    "route": "/multiplelocations",
                                },
                            ]
                        }
                    ],
                    "key": "multiplelocations"
                },
                //  {
                //      "type": "menu",
                //      "title": "Multiple Locations",
                //      "icon": "fa fa-sticky-note-o",
                //      "materialicon": "edit_location",
                //      "style": {
                //          'color': '#820404'
                //      },
                //      "link": [
                //          {
                //              "routes": [
                //                  {
                //                      "route": "/Records",
                //                      "routeParams": "key",
                //                  },
                //                  {
                //                      "route": "",
                //                      "routeParams": "routeid"
                //                  },
                //                  {
                //                      "route": "",
                //                      "routeParams": "routeid1"
                //                  },
                //                  {
                //                      "route": "/multiplelocations",
                //                  },
                //              ]
                //          }
                //      ],
                //      "key": "multiplelocations"
                //  },
                {
                    "type": "menu",
                    "title": "Attachments",
                    "icon": "fa fa-paperclip",
                    "materialicon": "attach_file",
                    "style": {
                        'color': '#f48fb1'
                    },
                    "link": [
                        {
                            "routes": [
                                {
                                    "route": "/Records",
                                    "routeParams": "key",
                                },
                                {
                                    "route": "",
                                    "routeParams": "routeid"
                                },
                                {
                                    "route": "",
                                    "routeParams": "routeid1"
                                },
                                {
                                    "route": "/attachments",
                                },
                            ],
                        }
                    ],
                    "key": "attachments"
                },
                {
                    "type": "menu",
                    "title": "Images",
                    "icon": "fa fa-files-o",
                    "materialicon": "wallpaper",
                    "style": {
                        'color': '#ffb300'
                    },
                    "link": [
                        {
                            "routes": [
                                {
                                    "route": "/Records",
                                    "routeParams": "key",
                                },
                                {
                                    "route": "",
                                    "routeParams": "routeid"
                                },
                                {
                                    "route": "",
                                    "routeParams": "routeid1"
                                },
                                {
                                    "route": "/images",
                                },
                            ],
                        }
                    ],
                    key: 'images'
                },
                {
                    "type": "menu",
                    "title": "Comments",
                    "icon": "fa fa-sticky-note-o",
                    "materialicon": "note",
                    "style": {
                        'color': '#b26a00'
                    },
                    "link": [
                        {
                            "routes": [
                                {
                                    "route": "/Records",
                                    "routeParams": "key",
                                },
                                {
                                    "route": "",
                                    "routeParams": "routeid"
                                },
                                {
                                    "route": "",
                                    "routeParams": "routeid1"
                                },
                                {
                                    "route": "/notes",
                                },
                            ],
                        }
                    ],
                    "key": "notes"
                },

                {
                    "type": "menu",
                    "title": "Notices",
                    "icon": "fa fa-files-o",
                    "materialicon": "tab",
                    "style": {
                        'color': '#8bc34a'
                    },
                    "link": [
                        {
                            "routes": [
                                {
                                    "route": "/Records",
                                    "routeParams": "key",
                                },
                                {
                                    "route": "",
                                    "routeParams": "routeid"
                                },
                                {
                                    "route": "",
                                    "routeParams": "routeid1"
                                },
                                {
                                    "route": "/notices",
                                },
                            ],
                        }
                    ],
                    key: 'notices'
                },



                {
                    "type": "menu",
                    "title": "Shared Discussions",
                    "icon": "fa fa-files-o",
                    "materialicon": "chat",
                    "style": {
                        'color': '#607d8b'
                    },
                    "link": [
                        {
                            "routes": [
                                {
                                    "route": "/Records",
                                    "routeParams": "key",
                                },
                                {
                                    "route": "",
                                    "routeParams": "routeid"
                                },
                                {
                                    "route": "",
                                    "routeParams": "routeid1"
                                },
                                {
                                    "route": "/discussions",
                                },
                            ],
                        }
                    ],
                    key: 'discussions'
                },
                {
                    "type": "menu",
                    "title": "Permit Amendments",
                    "icon": "fa fa-sticky-note-o",
                    "materialicon": "approval",
                    "style": {
                        'color': '#b26a00'
                    },
                    "link": [
                        {
                            "routes": [
                                {
                                    "route": "/Records",
                                    "routeParams": "key",
                                },
                                {
                                    "route": "",
                                    "routeParams": "routeid"
                                },
                                {
                                    "route": "",
                                    "routeParams": "routeid1"
                                },
                                {
                                    "route": "/permitamendments",
                                },
                            ],
                        }
                    ],
                    //hidecondition: [{ Name: "permitstage", Value: "WORK_PERMIT_APPROVED_EXTENDED_REACTIVATED" ,notEquals:true}],
                    "key": "permitamendments"
                },
                {
                    "type": "menu",
                    "title": "Notification Log",
                    "icon": "fa fa-envelope-o",
                    "materialicon": "notifications_active",
                    "style": {
                        'color': '#40c4ff'
                    },
                    "link": [
                        {
                            "routes": [
                                {
                                    "route": "/Records",
                                    "routeParams": "key",
                                },
                                {
                                    "route": "",
                                    "routeParams": "routeid"
                                },
                                {
                                    "route": "",
                                    "routeParams": "routeid1"
                                },
                                {
                                    "route": "/notificationlog",
                                },
                            ],
                        }
                    ],
                    "key": "notificationlog"
                },

                {
                    "type": "menu",
                    "title": "History",
                    "icon": "fa fa-files-o",
                    "materialicon": "history",
                    "style": {
                        'color': '#f44336'
                    },
                    "link": [
                        {
                            "routes": [
                                {
                                    "route": "/Records",
                                    "routeParams": "key",
                                },
                                {
                                    "route": "",
                                    "routeParams": "routeid"
                                },
                                {
                                    "route": "",
                                    "routeParams": "routeid1"
                                },
                                {
                                    "route": "/history",
                                },
                            ],
                        }
                    ],
                    key: 'history'
                },
            ]
        }
    },

    'MPSINQUIRIES': {
        "type": "applicationdrawer",
        "order": 2,
        "key": "drawer",
        "options": {
            "icon": "alarm",
            "open": true,
            "iconsonly": true,
            anchor: 'right',
            orientation: 'vertical',
            "items": [

                {
                    "type": "menu",
                    "title": "ParcelID's",
                    // "icon": "fa fa-inventory",
                    "materialicon": "local_post_office",
                    "style": {
                        'color': '#f44336'
                    },
                    "link": [
                        {
                            "routes": [
                                {
                                    "route": "/Records",
                                    "routeParams": "key",
                                },
                                {
                                    "route": "",
                                    "routeParams": "routeid"
                                },
                                {
                                    "route": "",
                                    "routeParams": "routeid1"
                                },
                                {
                                    "route": "/parcelids",
                                },
                            ],
                        }
                    ],
                    "key": "parcelids"
                },
            ]
        }


    },
}